import React from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import Cookies from "js-cookie";
import moment from "moment";
import "moment/locale/ru";

moment.locale("ru");
import Routes from "Configs/routes";
import { sendMetriks } from "Services/sendMetriks";
import { TARIFF_TV } from "Services/queries";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import {
	EVENT_CATEGORY_CLICK_BUTTON,
	EVENT_CATEGORY_LEAD,
} from "Constants/metriks/GoogleCategorys";
import {
	EVENT_ACTION_CONNECT_PROVIDER,
	CLICK_REDIRECT_LANDING,
} from "Constants/metriks/GoogleActions";
import { OfferLayout as MicroMarkupOfferLayout } from "Layouts/MicroMarkup";
import ConnectButton from "../ComponentsUI/ConnectButton";
import { ModalLayout } from "ComponentsUI/Modallayout";
import TariffCardV2Container from "ABTesting/Tests/TariffV2/Containers/TariffCardV2Container";

@withRouter
@inject("ApplicationModel")
@observer
export default class PlanBRowContainerV2 extends React.Component {
	closeModal() {
		let modalModel = this.props.ApplicationModel.modalModel;
		if (modalModel.isOpen) {
			modalModel.toggleModal();
		}
	}

	// Клик по количеству каналов
	onClickAddHandlerTv() {
		if (!!this.props.data.tv.use_text) {
			return;
		}

		this.closeModal();
		let modalModel = this.props.ApplicationModel.modalModel;
		let promise1 = import("Containers/ChannelsContainer");
		let apolloTariffQueryPromise = this.props.ApplicationModel.apolloTransportLayer.query({
			query: TARIFF_TV,
			variables: {
				id: this.props.data.id,
			},
		});
		Promise.all([promise1, apolloTariffQueryPromise]).then((modules) => {
			let ChannelsContainer = modules[0].default;
			let tariff = modules[1].data.tariffsOne;
			modalModel.toggleModal(
				<ModalLayout closeModal={() => this.closeModal()}>
					<ChannelsContainer tariff={tariff} />
				</ModalLayout>
			);
		});
	}

	// Клик по кнопке подключить
	clickConnectHandler() {
		let {
			ApplicationModel: { tariffsModel },
		} = this.props;
		let licenseFree = false;
		let connectTariffButton =
			this.props.ApplicationModel?.siteConfig?.settings?.connect_tariff_button?.[
				this.props.pageName
			] || "connect";

		let tariff = this.props.data;

		if (
			tariff?.after?.data?.price?.license_fee_month &&
			tariff?.after?.data?.price?.license_fee_month !== tariff.price.license_fee
		) {
			licenseFree = true;
		}
		if (licenseFree && connectTariffButton === "connect") {
			Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.CLICK_CONNECT_WITH_ACTION, []);
		}

		if (this.props.compareIsHideInConnectTariffs) {
			Metrika.getInstance().yandex.sendEvent(
				YANDEX_TARGETS.NEDAVNO_PODCLUCHENNYE_KARTOCHKA_PROVA,
				[]
			);
		}

		if (this.props.orderToHomeCompareBtnHidden) {
			Metrika.getInstance().yandex.sendEvent(
				YANDEX_TARGETS.NEDAVNO_PODCLUCHENNYE_ORDERS_TOHOME,
				[]
			);
		}

		if (this.props.isProviderCatalog && connectTariffButton !== "check_coverage") {
			Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.CLICK_TARIFF_FROM_CATALOG, []);
		}

		if (this.props.isRegionRatesTag && connectTariffButton === "connect") {
			Metrika.getInstance().yandex.sendEvent(
				YANDEX_TARGETS.CLICK_CONNECT_TARIFF_FROM_TAG_RATES,
				[]
			);
		}

		if (this.props.isRegionRatesTag && connectTariffButton === "check_coverage") {
			Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.CLICK_CHECK_ADDRESS_RATES_TAG, []);
		}

		if (this.props.isRating) {
			Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.CLICK_TARIFF_FROM_RATING, []);
		}

		if (this.props.isReviewsProviders) {
			sendMetriks("CLICK_TARIFF_FROM_OTZYVY_VIP");
		}

		if (this.props.isRates) {
			Metrika.getInstance().yandex.sendEvent(
				YANDEX_TARGETS.CLICK_CONNECT_TARIF_FROM_KARTOCHKA_RATES,
				[]
			);
		}

		if (this.props.isProviderRatesTags && connectTariffButton === "connect") {
			Metrika.getInstance().yandex.sendEvent(
				YANDEX_TARGETS.CLICK_CONNECT_TARIF_FROM_TAG_KARTOCHKA_RATES,
				[]
			);
		}
		if (this.props.isProviderRatesTags && connectTariffButton === "check_coverage") {
			Metrika.getInstance().yandex.sendEvent(
				YANDEX_TARGETS.CLICK_CHECK_ADDRESS_RATES_TAG_PROVIDER,
				[]
			);
		}

		if (this.props.isCard) {
			Metrika.getInstance().yandex.sendEvent(
				YANDEX_TARGETS.CLICK_CONNECT_TARIF_FROM_KARTOCHKA_O_PROVIDERE,
				[]
			);
		}

		if (this.props.isActionRegion) {
			sendMetriks("CLICK_CHECK_ADRESS_FROM_ACTIONS");
		}

		if (
			this.props.data?.provider?.vip_provider == 1 &&
			this.props.data?.provider?.provider_settings?.tariffs?.value === "button_text" &&
			connectTariffButton === "connect"
		) {
			sendMetriks("CLICK_NEW_TEXT");
		}

		if (Routes.RatesInHouse.route === this.props.match.path) {
			Cookies.set("connectTariffFrom", "from_popular_house");
		} else if (Routes.AddressStreet.route === this.props.match.path) {
			Cookies.set("connectTariffFrom", "from_street");
		} else if (Routes.AddressStreets.route === this.props.match.path) {
			Cookies.set("connectTariffFrom", "from_district");
		} else if (!!this.props.isProviderCatalog) {
			Cookies.set("connectTariffFrom", "catalog");
		} else if (!!this.props.isRegionRatesTag) {
			Cookies.set("connectTariffFrom", "rates_tags");
		} else if (!!this.props.isCardPage) {
			Cookies.set("connectTariffFrom", "kartochka_ne_vip");
		} else if (!!this.props.isOrderToHome) {
			Cookies.set("connectTariffFrom", "orders_tohome");
		} else if (!!this.props.isTS) {
			Cookies.set("connectTariffFrom", "TC");
		} else if (!!this.props.isExclusives || !!this.props.isMainPage) {
			Cookies.set("connectTariffFrom", "exclusive");
		} else if (!!this.props.isAboutProvider) {
			Cookies.set("connectTariffFrom", "kartochka_vip_about_provider");
		} else if (!!this.props.isActions) {
			Cookies.set("connectTariffFrom", "kartochka_vip_actions");
		} else if (!!this.props.isRates) {
			Cookies.set("connectTariffFrom", "rates_provider");
		} else if (!!this.props.isProviderRatesTags) {
			Cookies.set("connectTariffFrom", "tag_rates_provider");
		} else if (!!this.props.isRating) {
			Cookies.set("connectTariffFrom", "rating");
		} else if (!!this.props.isCard) {
			Cookies.set("connectTariffFrom", "kartochka_prova");
		} else if (this.props.is404) {
			Cookies.set("connectTariffFrom", "from_404");
		} else if (this.props.isActionRegion) {
			Cookies.set("connectTariffFrom", "actions_in_region");
		} else if (this.props.isReviewsProviders) {
			Cookies.set("connectTariffFrom", "vip_otzyvy");
		} else {
			Cookies.set("connectTariffFrom", "");
		}

		Metrika.getInstance().google.sendEvent(
			EVENT_CATEGORY_CLICK_BUTTON,
			EVENT_ACTION_CONNECT_PROVIDER
		);

		if (this.props.isTS || this.props.isActions) {
			sendMetriks("CLICK_CONNECT_TARIF");
		}

		tariffsModel.setTariff(tariff);
	}

	onClickHref = () => {
		window.open(this.props.data.provider.contacts.link, "_blank");
		Metrika.getInstance().google.sendEvent(EVENT_CATEGORY_LEAD, CLICK_REDIRECT_LANDING);

		return false;
	};

	render() {
		let data = this.props.data;

		let showActionButton = false;
		let siteConfig = this.props.ApplicationModel.siteConfig;

		let districtsArr = [];

		data.districts?.map((item) => {
			districtsArr.push(item.name);
		});

		let buttonConnect = (
			<ConnectButton
				data={data}
				showActionButton={showActionButton}
				compareIsHideInConnectTariffs={this.props.compareIsHideInConnectTariffs}
				orderToHomeCompareBtnHidden={this.props.orderToHomeCompareBtnHidden}
				pageName={this.props.pageName}
				action={this.props.action}
				recently={this.props.recently}
				isRates={this.props.isRates}
				isCard={this.props.isCard}
				onClickHref={this.onClickHref}
				position={this.props.position}
			/>
		);

		return (
			<MicroMarkupOfferLayout
				tariff={data}
				siteConfig={siteConfig}
				update_date={this.props.update_date}
			>
				<TariffCardV2Container
					data={data}
					onClickConnect={() => this.clickConnectHandler()}
					buttonConnectComponent={buttonConnect}
				/>
			</MicroMarkupOfferLayout>
		);
	}
}
